export default {
    productsResult: {
        products: [],
        productTypes: [],
        properties: [],
        bookingConditions: [],
        legalEntities: [],
        sites: [],
        invoiceProductTypes: []
    }
};
